import { render, staticRenderFns } from "./warehouseInfo.vue?vue&type=template&id=01dcbcaf&scoped=true&"
import script from "./warehouseInfo.vue?vue&type=script&lang=js&"
export * from "./warehouseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dcbcaf",
  null
  
)

export default component.exports